
export default [
    {
        path: '/',
        name: 'Tracking',
        component: () => import("../views/track.vue"),

        meta: {
            requiresAuth: true, // Si votre route nécessite une authentification
            title: 'Cartographie Tactique - OSINT'
        }
    },
    {
        path: '/tracking-map',
        name: 'TrackingMap',
        component: () => import("../views/TrackingMap.vue"),

        meta: {
            requiresAuth: true, // Si votre route nécessite une authentification
            title: 'Cartographie Tactique - OSINT'
        }
    },
    {
        path: '/assurances',
        name: 'Assurance',
        component: () => import("../views/PhoneInsuranceView.vue"),

        meta: {
            requiresAuth: true, // Si votre route nécessite une authentification
            title: 'Cartographie Tactique - OSINT'
        }
    },
];